import { useEffect, useState } from "react";
import { AddIcon } from "../../../../data/iconImage";
import { useAlert } from "../../../../context/AlertContext";
import { formatDate } from "../../../../commons/FormatValue";
import {
  deleteServiceRequest,
  getServiceRequest
} from "../../../../commons/ServiceRequest";
import Table from "../../../../components/Table";
import ButtonLink from "../../../../components/ButtonLink";
import SearchFilter from "../../../../components/SearchFilter";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import KeepPdfContsService from "../../../../services/keeppdfcont.service";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";

export default function StoreTab() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [data, setData] = useState([]);
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "ชื่อไฟล์แนบ",
      selector: (row) => row.Keep_File?.slice(14),
      grow: 2.5
    },
    {
      name: "วันที่นำเข้าเอกสาร",
      selector: (row) => row.Keep_Cont_Date,
      format: (row) => formatDate(row.Keep_Cont_Date)
    },
    { name: "นำเข้าโดย", selector: (row) => row.User_Permit },
    {
      name: "",
      selector: (row) => (
        <ButtonOptionSubmenu
          data={row}
          previewButton
          deleteButton
          state={{ preview: { name: "store", row } }}
          onDeleteCallback={(event, { Id }) =>
            deleteServiceRequest({
              showAlert,
              setLoading,
              serviceRequest: KeepPdfContsService.deleteKeepPdfConts(Id, false),
              refreshRequest: KeepPdfContsService.getAllKeepPdfConts(),
              callback: (res) => setData(res)
            })
          }
        />
      ),
      right: true,
      width: "180px"
    }
  ];
  const searchInput = [
    {
      name: "Contract_No",
      label: "เลขที่สัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select"
    },
    {
      name: "Contract_Start_Date",
      label: "วันที่เริ่มต้นสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Contract_End_Date",
      label: "วันสิ้นสุดสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Keep_Cont_Date",
      label: "วันที่",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      readOnly: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Customer.Cus_Code",
      label: "รหัสลูกค้าหลัก BP Master Code",
      type: "select",
      findValue: { value: "Customer.Cus_Code" }
    },
    {
      name: "Customer.Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      type: "text",
      size: 6,
      disabled: true,
      findValue: { value: "Customer.Cus_Code" }
    },
    { name: "User_Permit", label: "ผู้ใช้", type: "select", noneAsync: true }
  ];

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: KeepPdfContsService.getAllKeepPdfConts(),
      callback: (res) => setData(res)
    });
  }, []);

  return (
    <>
      <CardDisplayComponent
        body={{
          element: (
            <SearchFilter
              data={data}
              inputField={searchInput}
              fieldClassName={{
                inputRow: "justify-content-end",
                actionButton: "mt-3 text-end"
              }}
              searchCallback={(search) =>
                setSearchValue(
                  search?.length && search.some(({ value }) => value)
                    ? search
                    : []
                )
              }
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{
          className: "d-flex justify-content-between align-items-center",
          title: { text: "ไฟล์เอกสารสัญญา" },
          button: (
            <ButtonLink
              linkTo="create"
              stateData={{ name: "store" }}
              buttonName="นำเข้าไฟล์ .pdf"
              buttonClass="px-4 py-2 rounded-pill"
              iconSrc={AddIcon}
              iconName="Add Icon"
              iconClass="me-2 mb-1"
            />
          )
        }}
        body={{
          element: (
            <Table
              data={data}
              column={columns}
              searchFilter={searchValue}
              pending={loading}
              pagination
            />
          )
        }}
      />
    </>
  );
}
